import React from 'react';

const ServicesBusinessSetup = () => {
  return (
    <section id="business-setup" className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Business Setup in Bangladesh</h2>
        <p className="text-center mb-6">
          Start your business in Bangladesh with confidence. We offer end-to-end support for local and foreign companies to set up operations efficiently and compliantly.
        </p>
        <h3 className="text-xl font-semibold mb-4">Our Business Setup Support Includes:</h3>
        <ul className="list-none pl-4 space-y-1 mb-6">
          <li>✔️ <strong>Company Name Clearance</strong> – Reserve your company name through RJSC.</li>
          <li>
            ✔️ <strong>Company Registration (RJSC)</strong>
            <ul className="list-disc list-inside pl-4 space-y-1">
              <li>Drafting and filing Memorandum &amp; Articles of Association</li>
              <li>Obtaining Certificate of Incorporation</li>
            </ul>
          </li>
          <li>✔️ <strong>Trade License &amp; TIN</strong> – Apply through local City Corporation and NBR.</li>
          <li>
            ✔️ <strong>Bank Account &amp; Capital Remittance</strong>
            <ul className="list-disc list-inside pl-4 space-y-1">
              <li>Assistance in opening temporary and permanent accounts</li>
              <li>Foreign capital encashment support</li>
            </ul>
          </li>
          <li>✔️ <strong>VAT/BIN Registration</strong> – Register your business with NBR VAT Online system.</li>
          <li>✔️ <strong>BIDA Registration (For Foreign Investors)</strong> – Secure investment approval and work permit eligibility.</li>
          <li>✔️ <strong>Import/Export License (IRC/ERC)</strong> – Registration with CCI&amp;E for international trade.</li>
          <li>✔️ <strong>Work Permits &amp; Visas</strong> – Full visa support for directors and foreign employees.</li>
          <li>✔️ <strong>Office Setup Support</strong> – Rent space, furnish office, and hire local staff.</li>
          <li>✔️ <strong>Sector-Specific Licenses</strong> – Environmental, fire, and industry-specific permits.</li>
        </ul>
        <p className="text-center">
          Whether you're launching a new venture or expanding from abroad, our team ensures a smooth and compliant start in Bangladesh.
        </p>
        <p className="text-center mt-4">📩 Contact us today for a customized setup package.</p>
      </div>
    </section>
  );
};

export default ServicesBusinessSetup;
